import {
  Flex,
  Skeleton,
  SkeletonBodyText,
  SkeletonBox,
} from '@utilitywarehouse/hearth-react';

const SkeletonLoader = () => (
  <Skeleton loadingTitle="Energy details form loading" width="100%">
    <Flex direction="column" spacing="xl" width="100%">
      <Flex direction="column" spacing="md">
        <SkeletonBodyText />
        <SkeletonBox borderRadius="sm" height="48px" />
      </Flex>
      <Flex direction="column" spacing="md">
        <SkeletonBodyText />
        <SkeletonBodyText lines="2" />
        <SkeletonBox borderRadius="sm" height="72px" />
        <SkeletonBox borderRadius="sm" height="72px" />
        <SkeletonBox borderRadius="sm" height="72px" />
        <SkeletonBox borderRadius="sm" height="72px" />
      </Flex>
      <Flex direction="column" spacing="md">
        <SkeletonBodyText />
        <SkeletonBodyText lines="2" />
        <SkeletonBox
          borderRadius="sm"
          height="48px"
          width={{ desktop: '220px', mobile: '100%' }}
        />
      </Flex>
      <Flex direction="column" spacing="md">
        <SkeletonBodyText />
        <SkeletonBodyText lines="2" />
        <SkeletonBox
          borderRadius="sm"
          height="48px"
          width={{ desktop: '220px', mobile: '100%' }}
        />
      </Flex>
      <Flex direction="column" spacing="md">
        <SkeletonBodyText />
        <SkeletonBodyText lines="3" />
        <SkeletonBox
          borderRadius="sm"
          height="48px"
          width={{ desktop: '320px', mobile: '100%' }}
        />
      </Flex>
    </Flex>
  </Skeleton>
);

export { SkeletonLoader };
